import {Component, OnInit, inject} from '@angular/core';
import {AuthService} from '../../../service/authservice/auth.service';
import {Button} from 'primeng/button';
import {Router} from '@angular/router';

@Component({
  selector: 'app-login',
  imports: [
    Button
  ],
  templateUrl: './login.html',
  styleUrl: './login.css',
})
export class Login implements OnInit {
  private authService = inject(AuthService);
  private router = inject(Router);
  isLoading = false;

  ngOnInit(): void {
    if (this.authService.isAuthenticated()) {
      this.router.navigate(['/dashboard']);
    }
  }

  loginWithOAuth(): void {
    this.isLoading = true;
    this.authService.login().catch(() => {
      this.isLoading = false;
    });
  }
}
